import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';

import type { SxProps } from '@mui/system';

export const PageTitle = ({ children, sx, backButton = false }: {children: React.ReactNode; sx?: SxProps; backButton?: boolean}) => {
    const router = useRouter();
    const { t } = useTranslation('common');

    return (
        <Box sx={{ display: 'flex', mb: 4 }}>
            {backButton && (
                <Box sx={{ mr: 2 }}>
                    <Button
                        onClick={() => router.back()}
                        sx={{
                            backgroundColor: '#E9EDEC',
                            color: 'grey',
                            minHeight: '29px',
                            minWidth: '33px',
                            p: '0px',
                            padding: '13px',
                        }}
                        title={t('back')}
                        variant="text"
                    >
                        <FontAwesomeIcon icon={faArrowLeft} size="lg" />
                    </Button>
                </Box>
            )}
            <Typography component="h1" sx={sx} variant="h2">
                {children}
            </Typography>
        </Box>
    );
};

export const EmptyPage = ({ children, size = 'big', center = true }: {children: string; size?: 'small' | 'medium' | 'big'; center?: boolean }) => {
    const variant = size === 'small' ? 'h6'
        : size === 'medium' ? 'h5' : 'h4';
    return <Box alignItems={center ? 'center' : 'start'} display="flex" justifyContent={center ? 'center' : 'start'} p={3} width={1}><Typography component="p" gutterBottom variant={variant}>{children}</Typography></Box>;
};
